
import Vue from "vue";
import Component from "vue-class-component";
@Component({}) // Component装饰器装饰类
export default class HomePage extends Vue {
  name = "HomePage";
  banner = [
    {
      imgUrl: "../../../static/img/banner1.jpg",
    },
    {
      imgUrl: "../../../static/img/banner2.jpg",
    },
    {
      imgUrl: "../../../static/img/banner3.jpg",
    },
  ];
}
